<template>
  <div class="crafts">
    <el-card>
      <div slot="header" class="clearfix">
        <span>工艺流程</span>
      </div>
      <div class="tool-btn">
        <el-radio-group v-model="valueModel">
          <el-radio-button label="1">除尘器</el-radio-button>
          <el-radio-button label="2">RTO</el-radio-button>
        </el-radio-group>
      </div>
      <div class="main-cont1" v-if="valueModel === '1'">
        <div class="meter" v-for="(i, index) in tableData" :key="index" :id="i.deviceName" v-if="(i.deviceName === 'PT-1001' || i.deviceName === 'TT-1001')&&valueModel === '1'">
          <span>{{i.deviceName}}</span>
          <p><i :class="getStatus(i) ? 'r' : 'g'">{{i.qValue}}</i>{{i.unit}}</p>
        </div>
      </div>
      <div class="main-cont2" v-if="valueModel === '2'">
        <div class="meter" v-for="(i, index) in tableData" :key="index" :id="i.deviceName" v-if="i.deviceName !== 'PID-1001'&&i.deviceName !== 'PT-1001' && i.deviceName !== 'TT-1001' && i.deviceName !== 'PT-1008' && i.deviceName !== 'TT-1009' && i.deviceName !== 'PT-1009'&& valueModel === '2'">
          <span>{{i.deviceName}}</span>
          <p><i :class="getStatus(i) ? 'r' : 'g'">{{i.qValue}}</i>{{i.unit}}</p>
        </div>
        <div class="flow-value">
          <p>流量累计:{{flowNum}}m³</p>
          <el-button type="primary" size="mini" @click="clearData(1)">清零</el-button>
        </div>
        <div class="circle-value">
          <p>圈数累计:{{circleNum}}</p>
          <el-button type="primary" size="mini" @click="clearData(2)">清零</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import ApiService from "@/services/API-services";
export default {
  name: 'crafts',
  data() {
    return {
      valueModel: '2',
      tableData: [],
      flowNum: '',
      circleNum: ''
    }
  },
  created() {
    this.setTimer()
    this.$store.commit('showModal', {
      name: 'dataMonitorTable',
      show: true,
      left: '70px',
      top: '40px',
      data: null
    })
    // this.getRealDataLog()
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    clearData(val) {
      ApiService.tables.clearData({
        type: val
      }).then(res => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getRealDataLog()
        }
      })
    },
    getRealDataLog() {
      ApiService.tables.getRealDataLog().then(res => {
        if (res.code === 0) {
          this.flowNum = res.data.Flow,
          this.circleNum = res.data.NumberOfTurns
        }
      })
    },
    getStatus(row) {
      if (
        parseFloat(row.qValue) < parseFloat(row.offlineValues) ||
        parseFloat(row.qValue) > parseFloat(row.onlineValue)
      ) {
        return true;
      } else {
        return false;
      }
    },
    setTimer() {
      this.timer = setInterval(() => {
        this.getdevicelist()
        this.getRealDataLog()
      }, 3000);
    },
    getdevicelist() {
      ApiService.tree
        .devicelist({
          mileageID: window.R_config.modelId,
          page: 1,
          linit: 50,
          Type: 2
        })
        .then(res => {
          if (res.code == 0) {
            this.tableData = res.data;
          }
        });
    },
  } 
}
</script>
<style lang="scss">
@import '../../common/css/color.scss';
  .crafts {
    height: calc(100vh - 40px);
    position: relative;
    width: 1530px;
    .el-card__body {
      height: calc(100vh - 80px);
      padding: 0;
      background: url('../../assets/huayi_img/crafts_bg.png') no-repeat center;
      background-size: cover;
      box-sizing: border-box;
      padding: 20px;
      .tool-btn {
        display: flex;
      }
      .main-cont1,.main-cont2 {
        height: calc(100vh - 180px);
        position: relative;
        .meter {
          position: absolute;
          // top: 0;
          // left: 0;
          border: 1px solid #fff;
          width: 88px;
          // height: 54px;
          background: rgba(20, 71, 165, 0.63);
          display: flex;
          flex-direction: column;
          border-radius: 4px;
          box-sizing: border-box;
          span, p {
            height: 26px;
            line-height: 26px;
            text-align: left;
            color: #fff;
            padding: 0 5px;
            box-sizing: border-box;
          }
          span {
            border-bottom: 1px solid #fff;
            font-size: 13px;
          }
          p {
            font-size: 12px;
            i {
              font-style: normal;
              font-size: 16px;
              margin-right: 3px;
            }
            .g {
              color: rgba(27, 189, 107, 1);
            }
            .r {
              color: rgba(237, 65, 19, 1);
            }
          }
        }
        .flow-value {
          position: absolute;
          top: -4%;
          left: 31%;
          color: #fff;
          border: 1px solid #fff;
          border-radius: 5px;
          padding: 4px;
          font-size: 14px;
        }
        .circle-value {
          position: absolute;
          right: 14%;
          bottom: 17%;
          color: #fff;
          border: 1px solid #fff;
          border-radius: 5px;
          padding: 4px;
          font-size: 14px;
        }
        #PT-1004 {
          right: 23%;
          bottom: 27%;
        }
        #TT-1004 {
          right: 17%;
          bottom: 27%;
        }
        #PT-1006 {
          left: 22%;
          top: 18%;
        }
        #PT-1007 {
          right: 11%;
          top: 35%;
        }
        #TT-1006 {
          top: 18%;
          left: 28%;
        }
        #TT-2002 {
          top: -4%;
          right: 42%;
        }
        #TT-2001 {
          right: 47.5%;
          top: 12%;
        }
        #TT-1007 {
          right: 47.5%;
          top: 20%;
        }
        #TT-1008 {
          right: 47.5%;
          top: 35%;
        }
        #PT-1003 {
          right: 18%;
          bottom: 39.5%;
        }
        #TT-1003 {
          right: 11%;
          bottom: 39.5%;
        }
        #TT-2003 {
          right: 28%;
          top: 18%;
        }
        #PT-1005 {
          left: 14%;
          bottom: 39%;
        }
        #TT-1005 {
          left: 20%;
          bottom: 39%;
        }
        #PT-1002B {
          left: 43%;
          bottom: 19%;
        }
        #PT-1002A {
          left: 21%;
          bottom: 19%;
        }
        #TT-1002 {
          left: 27%;
          bottom: 19%;
        }
        #LNG {
          top: -4%;
          left: 24.5%;
        }
        #PT-1001 {
          top: 45%;
          left: 12%;
        }
        #TT-1001 {
          top: 45%;
          left: 18%;
        }
      }
      .main-cont1 {
        background: url('../../assets/huayi_img/chuchenqi.png') no-repeat center;
        background-size: contain;
      }
      .main-cont2 {
        background: url('../../assets/huayi_img/rto.png') no-repeat center;
        background-size: contain;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/mind/crafts.vue